'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Upload = require('./Upload');

var _Upload2 = _interopRequireDefault(_Upload);

var _Dragger = require('./Dragger');

var _Dragger2 = _interopRequireDefault(_Dragger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Upload2['default'].Dragger = _Dragger2['default'];
exports['default'] = _Upload2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/upload/index.js
// module id = 1027
// module chunks = 0